module.exports = __webpack_public_path__ + "img/B9CDD2_775339_958272_7F6A5E-256px.c29c5e43.png";